import type { ImagePath } from '@/core/lib/imageHelper';
import type { IEventExtraInfo, ITeam } from '@/interface/IEvent';
import type { ILeague } from '@/interface/ILeague';
import type { ISimpleEventResult } from '@/interface/ISimpleEventResult';
import type { IStream } from '@/interface/IStream';
import type { ITranslation } from '@/interface/ITranslation';
import type { BetTypeGroup, GroupTableColumn, MarketType, SportType, TournamentStage } from '@/interface/enum';

export interface ITournamentEvent {
    id: number;
    eventCode: string;
    eventDate: Date;
    hasStatistics: boolean;
    liveCourtMatchId: number;
    showTime: Date;
    showTimeType: number;
    marketTypeCount: Partial<Record<BetTypeGroup, Partial<Record<MarketType, number>>>>;
    isLive: boolean;
    isSimulation: boolean;
    isSboLive: boolean;
    absKickOffTime: Date;
    eventResults: ISimpleEventResult[];
    extraInfo: IEventExtraInfo | null;
    homeTeam: ITeam;
    awayTeam: ITeam;
    league: Omit<ILeague, 'region'>;
    sportType: SportType;
    stream: IStream | null;
    realKickoffTime: Date;
}

export interface IGroup {
    groupName: string;
    teamList: IGroupTeam[];
}

export interface IGroupTeam {
    id: number;
    name: ITranslation[];
    played: number | null;
    won: number | null;
    drawn: number | null;
    lost: number | null;
    goalDifference: number | null;
    points: number | null;
    ranking: number | null;
    isQualified: boolean;
    countryName: string;
}

export interface IGroupDisplay {
    groupName: string;
    teamList: IGroupTeamDisplay[];
}

export interface IGroupTeamDisplay {
    id: number;
    ranking: number;
    name: string;
    logo: ImagePath;
    valueMapping: Partial<Record<GroupTableColumn, number>>;
    countryName: string;
}

export interface IGroupColumn {
    key: GroupTableColumn;
    title: string;
    isShow: boolean;
}

export enum KnockoutEventStatus {
    Tbd = 'Tbd',
    Running = 'Running',
    Closed = 'Closed',
    End = 'End',
}

export interface IKnockoutTeam {
    id?: number;
    teamName: ITranslation[];
    countryName?: string;
}

export interface ISboEvent {
    id?: number;
    homeTeam: IKnockoutTeam | null;
    awayTeam: IKnockoutTeam | null;
    finalScore: { home: number, away: number } | null;
    status: number;
}

export interface IKnockoutStage {
    stage: TournamentStage;
    eventList: IKnockoutEvent[];
}

export interface IKnockoutEvent {
    datetime: Date | null;
    regularEvent: ISboEvent | null;
    extraTimeEvent: ISboEvent | null;
    penaltyEvent: ISboEvent | null;
    homeTeam: IKnockoutTeam | null;
    awayTeam: IKnockoutTeam | null;
    homePlaceHolder: string | null;
    awayPlaceHolder: string | null;
    status?: KnockoutEventStatus;
    runningEvent?: ITournamentEvent | null;
}

export interface ITournamentCenterStageConfig {
    [leagueId: string]: {
        [stageKey: string]: string;
    };
}
